/*
 * The backoffice sections (My usage, Consumo, Distribución, the exports): a title, a line of context,
 * then cards and tables drawn as the redesign mockup's `.card` and `.table`.
 */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionTitle {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.note {
  margin: 0;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background-color: var(--surface-sunken);
  color: var(--text);
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
}

.cardTitle {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.figures {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-1) var(--space-3);
  margin: 0;
  font-size: var(--font-size-13);
}

.figures dt {
  color: var(--text-muted);
}

.figures dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
}

/* The mockup's `.card.table-wrap` + `.table`: a bordered, rounded table with 13px text and hairlines. */
.table {
  inline-size: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--surface-raised);
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  text-align: start;
  vertical-align: middle;
}

.table thead th {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.table tbody th {
  font-weight: var(--font-weight-medium);
}

.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-block-end: 0;
}

.table tbody tr:hover {
  background-color: var(--surface-sunken);
}

.link {
  color: var(--text);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* Mockup v3 P7: the per-version breakdown of a mockup's row (v3 `.xbtn`, `.sub-row`). */
.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.toggleColumn {
  inline-size: 40px;
}

.toggle {
  display: inline-grid;
  place-items: center;
  inline-size: 28px;
  block-size: 28px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.toggle:hover {
  background: var(--surface-sunken);
  color: var(--text);
}

.toggle:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.toggle svg {
  transition: transform var(--duration-fast, 120ms) ease;
}

.toggle[aria-expanded="true"] svg {
  transform: rotate(180deg);
}

.subRow > td {
  background: var(--surface-sunken);
}

.breakdown {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.failedTurn th,
.failedTurn td {
  color: var(--text-muted);
}

@media (prefers-reduced-motion: reduce) {
  .toggle svg {
    transition: none;
  }
}

.caption {
  padding: var(--space-2) var(--space-3) 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
  text-align: start;
  caption-side: top;
}
